import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";
import AutoCompleteDropdown from "../../../../Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../Hooks/useForm";
import { toastShow } from "../../../../Services/ToastService";

import {
  agregarPrioridades,
  obtenerPrioridades,
} from "../../../../API/Global/Prioridades/PrioridadesRequests";
import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";
import Loader from "../../../../Components/Loader/Loader";
import { AuthContext } from "../../../../Context/AuthContext/AuthContext";

const CrudPrioridadesModal = ({
  toastRef,
  prioridad,
  prioridadesDialog,
  setPrioridadesDialog,
  getPrioridades,
  modo,
}) => {
  const toast = useRef(null);

  const [show, setShow] = useState(false);

  const [estados, setEstados] = useState([{}]);
  const [prioridades, setPrioridades] = useState([{}]);
  const [loading, setLoading] = useState(false);
  const { userAuth } = useContext(AuthContext);

  const initialValues = {
    IdPriority: -1,
    PriorityCategory: "",
    Priority: "",
    IdStatus: prioridad ? prioridad?.IdStatus : 5,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true)
    const estadosTempo = await getEstadosCategory("General");
    const unidades = await obtenerPrioridades();
    setEstados(estadosTempo);
    setPrioridades(unidades);

    const estadoInicial =
      modo === "Crear"
        ? estadosTempo[0]
        : estadosTempo.find((e) => e.IdStatus === prioridad?.IdStatus);

    setValues({
      ...prioridad,
      Estado: estadoInicial,
      IdStatus: estadoInicial.IdStatus,
    });
    setLoading(false)
  };

  const onHide = () => {
    setPrioridadesDialog(false);
    resetForm();
    setShow(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.PriorityCategory) {
      error.PriorityCategory = true;
      error.error = true;
    }
    if (!values.Priority) {
      error.Priority = true;
      error.error = true;
    }
    if (!values.Estado || !values.Estado.IdStatus) {
      error.IdStatus = true;
      error.error = true;
    }
    setError(error);
    console.log(error);
    return error;
  };

  const agregarPrioridad = async () => {
    const e = verificarInfo();

    if (!e.error) {
      let estadoId = null;
      if (values.Estado) {
        estadoId = values.Estado.IdStatus;
      }
      const a = {
        IdPriority: values?.IdPriority,
        PriorityCategory: values.PriorityCategory,
        Priority: values.Priority,
        IdStatus: estadoId,
        IdUserCreate: userAuth?.IdUser
      };

      const dialogTitle = modo === "Crear" ? "Registro Guardado exitosamente." : "Registro Actualizado exitosamente.";
      const resultado = await agregarPrioridades(a);

      setLoading(true)
      toastShow(toastRef, "success","Datos Agregados", dialogTitle);
      toastShow(toast, "success", "Datos Agregados", dialogTitle);
      getPrioridades();
      setTimeout(() => {
        onHide();
        setLoading(false)
      }, 1000);
    } else {
      toastShow(
        toast,
        "error",
        "Error",
        "Error, completa los campos requeridos."
      );
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          if (modo === "Crear") {
            agregarPrioridad();
          } else {
            agregarPrioridad();
          }
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (prioridadesDialog) {
      getValoresIniciales();
    }
  }, [prioridadesDialog]);

  const dialogTitle =
    modo === "Crear" ? "Agregar Prioridad" : "Modificar Prioridad";

  return (
    <div>
      <Dialog
        visible={prioridadesDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <div id="pDialog">
          <Loader loading={loading} querySelector={"#pDialog"} />
          <Toast ref={toast} style={{ zIndex: 50000 }} />
          <ConfirmDialog />
          <div className="d-flex align-items-center">
            <h2 className="me-3">{dialogTitle}</h2>
          </div>
          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="PriorityCategory"
                  value={values.PriorityCategory}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.UnitName ? "p-invalid" : ""}
                />
                <label htmlFor="PriorityCategory">Categoría</label>
                {error.PriorityCategory && (
                  <small
                    className="p-error block"
                    style={{ position: "static", top: 1 }}
                  >
                    Campo Requerido.
                  </small>
                )}
              </span>
            </div>

            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="Priority"
                  value={values.Priority}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                />
                <label htmlFor="Priority">Priodidad</label>
                {error.Priority && (
                  <small
                    className="p-error block"
                    style={{ position: "static", top: 1 }}
                  >
                    Campo Requerido.
                  </small>
                )}
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"Estado"}
                  value={values.Estado}
                  items={estados}
                  field={"StatusName"}
                  label={"Estado"}
                  handleInputChange={handleInputChange}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.Estado ? "p-invalid" : ""}
                />
                {error.IdStatus && (
                  <small
                    className="p-error block"
                    style={{ position: "absolute", top: 41 }}
                  >
                    Campo Requerido.
                  </small>
                )}
              </span>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default CrudPrioridadesModal;
